import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const associationRegisterService = {
  getAll,
  createOrUpdate,
  deleteRegister
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL
  }/api/associations_registers/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function createOrUpdate(newRegister) {
  const requestOptions = {
    method: newRegister.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newRegister)
  };

  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/associations_registers${
    newRegister.id ? `/${newRegister.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}
function createBodyRequest(register) {
  let formData = new FormData();

  formData.append('associations_register[title]', register.title);
  formData.append('associations_register[add_date]', register.date);

  const document = register.document;

  if (document) {
    if (document.url) {
      formData.append(`associations_register[document]`, document.url);
    } else {
      formData.append(
        `associations_register[document]`,
        document,
        document.name
      );
    }
  }

  return formData;
}
function deleteRegister(registerId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }
  let url = `${
    process.env.REACT_APP_API_URL
  }/api/associations_registers/${registerId}`;

  return axios.delete(url, requestOptionsDelete);
}
